import type { ApiSchemas } from '@rental/contracts/client'
import type { StaffLocale } from '@rental/domain'
import { format, localized, type StaffMessages } from '@rental/i18n'

type QuoteLine = ApiSchemas['QuoteLine']

/** One line of a quote in staff words: names come from the line, in the screen's language. */
export function lineLabel(line: QuoteLine, locale: StaffLocale, m: StaffMessages): string {
  const name = line.name ? localized(line.name, locale) : null
  let label: string
  switch (line.kind) {
    case 'rental':
      label = name ? `${m.quoteLines.rental} · ${name}` : m.quoteLines.rental
      break
    case 'surcharge':
      label = line.code === 'young_driver' ? m.youngDriver : (name ?? m.quoteLines.surcharge)
      break
    case 'discount':
      label = format(m.quoteLines.discount, { code: line.code })
      break
    case 'one_way':
      label = m.quoteLines.one_way
      break
    default:
      label = format(m.quoteLines[line.kind], { name: name ?? line.code })
  }
  return line.quantity > 1 ? `${line.quantity} × ${label}` : label
}
